<div class="bg-[#F5F5F5] min-h-screen">
	<div class="flex flex-col justify-end min-h-screen">
		<div>
			<div class="mx-[20px]">
				<ng-container *ngTemplateOutlet="body"></ng-container>
			</div>
			<div class="mx-[20px] mt-44">
				<ng-container *ngTemplateOutlet="footer"></ng-container>
			</div>
		</div>
	</div>
</div>
<ng-template #body>
	<div class="py-14 flex flex-col justify-center items-center">
		<div>
			<svg width="125" height="125" viewBox="0 0 125 125" fill="none" xmlns="http://www.w3.org/2000/svg">
				<circle cx="62.5" cy="62.5" r="62.5" fill="#BCE8C0"/>
				<circle cx="62.5" cy="62.5" r="49.5" fill="#1EB12D"/>
				<circle cx="62.5" cy="62.5" r="38.5" fill="#18902C"/>
				<path d="M43.7568 62.3746C45.0984 61.0728 47.2719 61.0708 48.6152 62.3701L54.3122 67.8796C54.7513 68.3046 55.462 68.3042 55.9011 67.8783L75.3649 48.9803C76.7149 47.67 78.9044 47.6737 80.2494 48.9885C81.5868 50.2972 81.5834 52.4098 80.2401 53.7136L58.8257 74.5046C56.7717 76.4985 53.4425 76.4985 51.3884 74.5046L43.7568 67.0956C42.4144 65.7918 42.4144 63.6783 43.7568 62.3746Z" fill="white"/>
			</svg>
		</div>
		<div class="max-w-[335px] mx-auto text-center">
			<div class="mt-[32px]">
				<div class="text-[32px] leading-[39.68px] font-bold text-black">
					{{title}}
				</div>
			</div>
			<div class="mt-[12px]">
				<div class="text-[12px] leading-[17.76px] font-normal text-[#333]">
					{{description}}
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #footer>
	<div class="pb-[40px] pt-[24px]">
		<div (click)="dismiss()" class="cursor-pointer h-[48px] items-center flex justify-center bg-[#0357EE]/10 rounded-[8px] py-[6px] px-[16px]">
			<div class="text-[14px] leading-[17.36px] font-medium text-[#0361F0]">
				Dismiss
			</div>
		</div>
	</div>
</ng-template>

